import { getSharedState as n } from "../../utilities/state/index.js";
const r = {
  values: {}
}, t = n(
  "config",
  r
), g = () => t.get(), i = (e, o, s) => {
  t.switchContext({ countryCode: e, brand: o }), t.set({ values: s });
}, f = () => {
  t.reset();
};
export {
  t as CONFIG_STATE,
  g as getConfig,
  f as resetConfig,
  i as setConfig
};
//# sourceMappingURL=index2.js.map
